<template>
	<van-popup
		:show="show"
		@update:show="emitUpdateShow"
		position="bottom"
		safe-area-inset-bottom
	>
		<van-date-picker
			v-model="dateValue"
			title="选择日期"
			v-bind="datePickerProps"
			@confirm="onConfirm"
			@cancel="onCancel"
			@change="onChange"
		/>
	</van-popup>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			required: true
		},
		minDate: {
			type: String
		},
		maxDate: {
			type: String
		},
		modelValue: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			dateValue: []
		}
	},
	watch: {
		modelValue(val) {
			this.dateValue = val.slice(0)
		}
	},
	computed: {
		datePickerProps() {
			const { minDate, maxDate } = this
			const temp = {}
			if (minDate) {
				temp.minDate = new Date(minDate)
			}
			if (maxDate) {
				temp.maxDate = new Date(maxDate)
			}
			return temp
		}
	},
	mounted() {},
	methods: {
		onConfirm({ selectedValues, selectedOptions }) {
			console.log(this.dateValue)
			this.$emit('update:model-value', this.dateValue, {
				selectedValues,
				selectedOptions
			})
			this.emitUpdateShow(false)
		},
		onCancel({ selectedValues, selectedOptions }) {
			this.dateValue = this.modelValue.slice(0)
		},
		onChange({ selectedValues, selectedOptions, columnIndex }) {
			this.$emit('change', { selectedValues, selectedOptions, columnIndex })
		},
		emitUpdateShow(val) {
			this.$emit('update:show', val)
		}
	},
	components: {}
}
</script>

<style lang="scss" scoped="scoped"></style>
